import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pop_banner_tit" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "pop_btn_wrap" }
const _hoisted_4 = { class: "close_btn checkbox_wrap" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pop_banner", $setup.state.item.location == 'L' ? 'pop_left' : $setup.state.item.location == 'M' ? 'pop_middle' : 'pop_right']),
    style: _normalizeStyle({ display: 'block', zIndex: 99 - $setup.state.item.orderNo })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString($setup.state.item.title), 1)
    ]),
    _createElementVNode("div", {
      class: "content_wrap icon_wrap",
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.item.link && $setup.moveLink($setup.state.item.link))),
      style: _normalizeStyle({ cursor: $setup.state.item.link ? 'pointer' : 'default' })
    }, [
      _createElementVNode("img", {
        src: $setup.state.item.file,
        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
      }, null, 40, _hoisted_2)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.state.item.isSettingClose === 1)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: $setup.state.item.idx
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                id: $setup.state.item.idx,
                onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isNoShowToday = !$setup.state.isNoShowToday))
              }, null, 40, _hoisted_6),
              _cache[4] || (_cache[4] = _createElementVNode("em", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "no_blue" }, "오늘 하루 안보기", -1))
            ], 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
      }, "닫기")
    ])
  ], 6)), [
    [_vShow, $setup.state.isShow]
  ])
}